export const PROCESSING_STATES = {
  initial: 'initial',
  loading: 'loading',
  error: 'error',
  success: 'success',
};

export default PROCESSING_STATES;
